import React from "react";
import { contactFields } from "../../../../../configs/customer";
import {
  ContentWrapper,
  DeleteButton,
  AddButtonText,
  StyledAddButton,
} from "./Styled";
import AddSectionIcon from "../../../../../shared/svg/AddSection";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import { color } from "../../../../../shared/styles";
import FormType from "../../../../../shared/components/FormType";
import { WarningContactPerson } from "./Styled";

interface ContactListProps {
  contactList: any[];
  onChangeContactList: Function;
  onDeleteContactList: Function;
  onAddContactList: Function;
  validated: boolean;
}

const ContactList = ({
  contactList,
  onChangeContactList,
  onDeleteContactList,
  onAddContactList,
  validated,
}: ContactListProps) => {
  return (
    <>
      {contactList.map((contact, index) => (
        <ContentWrapper key={contact.id}>
          <FormType
            requireData={{ ...contact, is_default: contact.contact.is_default }}
            mergeFormData={onChangeContactList}
            title={`Thông tin người liên hệ ${index + 1}`}
            fields={contactFields}
            validated={validated}
            style={{
              formWrapper: {
                backgroundColor: "#F7F7F7",
                borderRadius: "8px",
                padding: "24px 20px",
                margin: "20px 20px 0 20px",
              },
              contentWrapper: {
                boxShadow: "none",
              },
            }}
          />

          <DeleteButton
            onClick={() => onDeleteContactList(contact.id)}
            disabled={contact.contact.is_default}
          >
            <DeleteIcon color={color.secondary.CHARCOAL} />
          </DeleteButton>
        </ContentWrapper>
      ))}
      <StyledAddButton onClick={() => onAddContactList()}>
        <AddButtonText>Thêm người liên hệ</AddButtonText>
        <AddSectionIcon />
      </StyledAddButton>
    </>
  );
};

export default ContactList;
